import { useTranslation } from 'next-i18next/pages';
import classNames from 'classnames';

import { LotCard, Scrollable, ILotCard } from '@catawiki/cata-style';

import { cleanBuilderStringInput } from '@/shared/text';
import { EnrichedLot } from '@/shared/models/lot';

interface Props {
  title?: string;
  url: string;
  numberOfLots: number;
  lots: EnrichedLot[];
  className?: string;
  hidden?: boolean;
}

const convertToLotCardLot = (
  lot: EnrichedLot,
  statusText: string
): ILotCard => ({
  title: lot.title,
  imageUrl: lot.imageUrl,
  lotUrl: lot.lotUrl,
  status: undefined,
  statusText,
});

function ExploreMoreLink({ link }: { link: string }) {
  const { t } = useTranslation();

  if (!link) return null;

  return (
    <a
      className="u-typography-h6 tw:text-brand-primary"
      href={cleanBuilderStringInput(link, true)}
    >
      {t('bid_status_section.explore_more')}
    </a>
  );
}

function TitleBlock({
  title,
  exploreMoreUrl,
}: {
  title: string;
  exploreMoreUrl: string;
}) {
  if (!title && !exploreMoreUrl) return null;
  return (
    <div className="tw:flex tw:justify-between u-m-b-xl">
      <h6 className="u-typography-h6">
        {cleanBuilderStringInput(title, true)}
      </h6>
      <ExploreMoreLink link={exploreMoreUrl} />
    </div>
  );
}

export const FeaturedLots = ({
  title = 'Featured Objects',
  lots = [],
  url,
  className = '',
  hidden = false,
  numberOfLots,
}: Props) => {
  const { t } = useTranslation();
  if (hidden) return null;
  return (
    <div
      className={classNames(
        {
          'p-featured-lots__four-items': numberOfLots === 4,
        },
        'p-featured-lots',
        className
      )}
    >
      <TitleBlock title={title} exploreMoreUrl={url} />
      <Scrollable listClassName="tw:items-center u-g-m">
        {lots.map((lot) => {
          const lotStatusText = lot.closed
            ? t('similar_lots.sold_for')
            : t('short_auction_current_bid');
          return (
            <LotCard
              lot={convertToLotCardLot(lot, lotStatusText)}
              price={lot.price}
              key={lot.id}
            />
          );
        })}
      </Scrollable>
    </div>
  );
};
